var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.309,
    height: 35.361,
    viewBox: "0 0 30.309 35.361",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "timer-icon",
    d: "M24.706,1.5H14.6V4.868h10.1ZM17.971,23.39h3.368v-10.1H17.971ZM31.492,12.26l2.391-2.391a18.6,18.6,0,0,0-2.374-2.374L29.118,9.886a15.153,15.153,0,1,0,2.374,2.374ZM19.655,33.493A11.787,11.787,0,1,1,31.441,21.706,11.778,11.778,0,0,1,19.655,33.493Z",
    transform: "translate(-4.5 -1.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer-icon.cd7b73aa42bcb2e4912a767d72f93dc5.svg";
export { ForwardRef as ReactComponent };